import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { saveAndContinueRehydrateSlice } from '../storeUtils';
import { mockOutletList } from '../../../screens/OutletPage/OutletPage';

interface OutletState {
  selectedOutlet: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData | null;
  favouriteCompanyId: string | undefined;
}

const initialState: OutletState = {
  selectedOutlet: mockOutletList[0],
  favouriteCompanyId: undefined,
};

const name = 'outlets';

export const outletSlice = createSlice({
  name,
  initialState,
  reducers: {
    saveSelectedOutlet: (
      state,
      action: PayloadAction<DealerIntegration.Components.Schemas.MilesBrokerCompaniesData>
    ) => {
      state.selectedOutlet = action.payload;
    },
    setFavouriteCompanyId(state, { payload }: PayloadAction<string | undefined>) {
      state.favouriteCompanyId = payload;
    },
  },
  extraReducers: (builder) => {
    saveAndContinueRehydrateSlice(builder, name);
  },
});

export const getSelectedOutlet = (state: RootState) => state.outlets.selectedOutlet;
export const getFavouriteCompanyId = (state: RootState) => state.outlets.favouriteCompanyId;

export const { saveSelectedOutlet, setFavouriteCompanyId } = outletSlice.actions;

export const outletReducer = outletSlice.reducer;
